import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { NotifyMeActions } from '../constants/notify_me/notify_me_actions';
import { NotificationTypes } from '../constants/notify_me/notification_types';

class NotifyMeStoreClass extends ReduceStore {
    getInitialState() {
        return {
            name: '',
            email: '',
            phone: '',
            sku: '',
            quantity: 4,
            marketingConsent: false,
            visible: false,
            emailInvalid: false,
            phoneInvalid: false,
            isSubmitted: false,
            isError: false,
            errorMsg: '',
            notificationType: NotificationTypes.OUT_OF_STOCK,
            tyreQuantityOptions: Array.from({ length: 20 }, (_, i) => ([[i + 1], i + 1])),
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.NOTIFY_ME_ACTION) {
            const { type, payload } = action;

            switch (type) {
                case NotifyMeActions.SHOW_ACTION:
                    if (!state.visible) {
                        state.isSubmitted = false;
                        state.isError = false;
                        state.errorMsg = '';
                        state.quantity = 4;
                        state.visible = true;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.HIDE_ACTION:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_QUANTITY_ACTION:
                    if (state.quantity !== payload) {
                        state.quantity = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_NAME_ACTION:
                    if (state.name !== payload) {
                        state.name = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_MARKETING_CONSENT_ACTION:
                    if (state.marketingConsent !== payload) {
                        state.marketingConsent = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_EMAIL_ACTION:
                    if (state.email !== payload) {
                        state.email = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_PHONE_ACTION:
                    if (state.phone !== payload) {
                        state.phone = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_SKU_ACTION:
                    if (state.sku !== payload) {
                        state.sku = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.EMAIL_INVALID_ACTION:
                    if (!state.emailInvalid) {
                        state.emailInvalid = true;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.EMAIL_VALID_ACTION:
                    if (state.emailInvalid) {
                        state.emailInvalid = false;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.PHONE_INVALID_ACTION:
                    if (!state.phoneInvalid) {
                        state.phoneInvalid = true;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.PHONE_VALID_ACTION:
                    if (state.phoneInvalid) {
                        state.phoneInvalid = false;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.SET_TYPE_ACTION:
                    if (state.notificationType !== payload) {
                        state.notificationType = payload;
                        this.__emitChange();
                    }
                    break;
                case NotifyMeActions.FORM_SUBMIT:
                    if (!state.isSubmitted) {
                        state.name = '';
                        state.email = '';
                        state.phone = '';
                        state.isSubmitted = true;
                        if (payload && payload.isError) {
                            state.isError = true;
                            state.errorMsg = payload.message;
                        }
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const NotifyMeStore = new NotifyMeStoreClass(Dispatcher);
export default NotifyMeStore;
